import type { SuretyAccountId, SuretyBondId } from "@inrev/common";
import { useFetchBondTerms } from "@portal/api/bond";
import { BondTermsCard } from "@portal/components/features/bond-terms";
import type { FC } from "react";

type AgentBondPeriodsTabProps = {
	accountId: SuretyAccountId;
	bondId: SuretyBondId;
};

export const AgentBondPeriodsTab: FC<AgentBondPeriodsTabProps> = ({ accountId, bondId }) => {
	const { terms, termsLoading } = useFetchBondTerms(accountId, bondId);

	return (
		<div data-testid="agent-bond-periods-tab">
			{!termsLoading && <BondTermsCard terms={terms} />}
		</div>
	);
};
